import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { asArray } from '@olivierpascal/helpers';
import { useStyles } from '../../hooks/useStyles';
import { Elevation } from '../Elevation';
import { List } from '../List';
import { Base } from '../Base';
import { menuListElevationStyles, menuListListStyles, menuListStyles, } from './MenuList.styles';
import { menuListTheme } from './MenuList.stylex';
export const MenuList = forwardRef(function MenuList(props, forwardedRef) {
    const { styles, sx, innerStyles, children, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'MenuList',
        styles: [menuListStyles, styles],
    });
    return (_jsxs(Base, { sx: [menuListTheme, globalStyles, combineStyles('host'), sx], ref: forwardedRef, children: [_jsx(Elevation, { styles: [menuListElevationStyles, ...asArray(innerStyles?.elevation)] }), _jsx(List, { styles: [menuListListStyles, ...asArray(innerStyles?.list)], ...other, children: children })] }));
});
